import React from 'react';
import { weekDays } from '../../TransferenciaAgendamento/constants';
import ClickableTablecell from '../components/ClickableTablecell';

import { TableCellText } from '../components/ClickableTablecell/styles';

export const getProcedimentosTableHeader = ({ onClick, idPrefix = 'cfg-prt' }) => {
  return [
    {
      Header: 'Horário',
      getValue: row => row.horaInicio,
      props: { center: 'true' },
    },
    ...weekDays.map(({ value }, dayIndex) => ({
      Header: value.substring(0, 3),
      getValue: (row, rowIndex) => {
        const isDisabled = !row[value]?.permiteAgendamento;
        const handleClick = () => onClick(row[value]);
        const procedimentosCount = row[value]?.procedimentos?.length || 0;
        const isOnline = row[value]?.permiteAgendamentoOnline;

        const labels = [
          isOnline ? 'Online' : '',
          procedimentosCount > 0 ? `${procedimentosCount} proc.` : '',
        ].filter(Boolean).join(' | ');

        return (
          <ClickableTablecell id={`${idPrefix}-cel-${value}-${rowIndex}`} disabled={isDisabled} onClick={!isDisabled && handleClick}>
              <TableCellText style={labels ? { fontWeight: 500 } : undefined}>
                {labels || (isDisabled ? '' : '—')}
              </TableCellText>
          </ClickableTablecell>
        )
      },
      center: 'true',
      isClick: true
    })),
  ];
};
